
























import {defineComponent, ref} from "@vue/composition-api"

export default defineComponent({
  name: 'Chips',
  props: {
    value: {
      type: Array as () => string[],
      default: []
    }
  },
  setup({value}, {emit}) {
    const chips = ref<string[]>(value)
    const input = ref<string>('')

    function onInput() {
      if (!input.value) return
      chips.value.push(input.value)
      input.value = ''
      emit('input', chips.value)
    }

    return {
      input,
      chips,
      onInput,
      remove(chip: string) {
        chips.value = chips.value.filter(x => x !== chip)
        emit('input', chips.value)
      }
    }
  }
})
